import { Controller } from "@hotwired/stimulus"

// Drops the server rendered error of the field being corrected: it walks up from
// the field to the block that owns an error message and removes that message
// together with the red styling.
export default class extends Controller {
  clear(event) {
    const message = this.ownedMessage(event.target)
    if (!message) return

    const field = message.parentElement
    field.classList.remove("text-red-500")
    message.remove()

    // Rails wraps an invalid input in a div of its own, which breaks the layout.
    const focused = document.activeElement
    field.querySelectorAll(".field_with_errors").forEach((wrapper) => wrapper.replaceWith(...wrapper.childNodes))
    focused?.focus()
  }

  ownedMessage(element) {
    for (let node = element; node && node !== this.element; node = node.parentElement) {
      const message = node.querySelector(":scope > [data-error-message]")
      if (message) return message
    }

    return null
  }
}
